import {MakeSimpleCondition} from "../engine/Condition";
import {merchantVariableModule} from "../../merchant-state/MerchantVariableModule";


export interface VariableConditionOptions {
    key: string;
    equal?: any;
}

function verifyVariable(options: VariableConditionOptions) {
    const value = merchantVariableModule.get(options.key);
    return options.hasOwnProperty("equal") ? (value === options.equal) : value;
}

export const VariableCondition = MakeSimpleCondition<VariableConditionOptions>(verifyVariable, merchantVariableModule);
